import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
              热门资讯
            </h2>
            <p className="mt-1 text-sm text-foreground-500">最新彩票资讯与分析文章</p>
          </div>
          <Link
            to="/category/shuangseqiu"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded-md self-start mb-2">
                  {article.categoryName}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-calendar-line mr-1"></i>
                    {article.date}
                  </span>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-time-line mr-1"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/shuangseqiu"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}